import { useAuth } from "../contexts/AuthContext";
import { useEffect, useState } from "react";
import Auth from "../partials/Auth";
import { Link } from "react-router-dom";
import { useFirebase } from "../contexts/FirebaseContext";
import Button from "../components/Buttons/Button";
import TextInput from "../components/TextInput";
import PractionerCard from "../components/PractitonerCard";
import { useProvider } from "../contexts/ProviderContext";
import { useData } from "../contexts/DataContext";
import { EventData } from "../types/firebase";
import FeaturedCard from "../components/FeaturedCard";
import { EMAIL } from "../utils/constants";
import FollowingList from "../components/FollowingList";

const ProfilePage: React.FC = () => {
  const { currentUser, loading, logout } = useAuth();
  const { hasProvider, providerData } = useProvider();
  const { eventsData } = useData();
  const [userEvents, setUserEvents] = useState<EventData[]>([]);

  useEffect(() => {
    if (providerData && eventsData) {
      const filteredEvents = eventsData.filter(
        (event) => event.providerDetails?.owner_id === currentUser?.uid
      );
      setUserEvents(filteredEvents);
    }
  }, [providerData, eventsData, currentUser]);

  const app = useFirebase();

  const handleLogout = async () => {
    try {
      await logout();
      // setProviderData(null); to do find away to ut this back
    } catch (error) {
      // Handle error if needed
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Auth />;
  }

  const renderProviderButton = () => {
    if (hasProvider === null) {
      return <div className="text-gray-600">Loading...</div>;
    }

    return hasProvider ? null : (
      <div className="flex flex-col items-start">
        <p className="text-gray-600 text-sm mb-4">
          Want to list your events and grow your community?
        </p>
        <div className="self-end">
          <Link to="/submit_provider">
            <Button>Register as a Provider</Button>
          </Link>
        </div>
      </div>
    );
  };

  const isPending = providerData?.approved === false;
  const isApproved = providerData?.approved === true;

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6 mt-8">Profile</h1>

      <div className="max-w-2xl space-y-6 mt-16">
        <TextInput
          label="Email"
          value={currentUser?.email || ""}
          onChange={() => null}
          disabled
          readOnly
        />
        {hasProvider && providerData && (
          <PractionerCard
            clickable={false}
            provider={providerData}
            hoverable={false}
            pills={
              isPending
                ? [{ text: "Pending Approval", colorClass: "bg-muted-grey" }]
                : [{ text: "Approved", colorClass: "bg-muted-moss" }]
            }
          />
        )}

        <div className="pt-16">
          {isPending ? (
            <p className="text-gray-600 text-xl mb-2 font-noto italic font-light pb-8">
              We have received your practitioner submission and will review. If you have any questions please email{' '}
              <a href={`mailto:${EMAIL}`} className="text-muted-sage hover:underline">
                {EMAIL}
              </a>
            </p>
          ) : (
            <p className="text-gray-600 text-xl mb-2 font-noto italic font-light pb-8">
              Want to list your events and grow your community?
            </p>
          )}
          <div className="flex items-start">
            <div className="flex-grow">
              {!hasProvider && (
                <Link to="/submit_provider">
                  <Button>Register as a Practitioner</Button>
                </Link>
              )}
              {isApproved && (
                <Link to="/submit">
                  <Button>Submit New Event</Button>
                </Link>
              )}
            </div>
            <Button onClick={handleLogout} color="sage">
              Logout
            </Button>
          </div>
        </div>
      </div>
      {isApproved && (
        <div>
          <h2 className="text-xl font-bold mb-4 mt-4">Your Events</h2>
          {userEvents.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {userEvents.map((event) => (
                <FeaturedCard key={event.id} event={event} location="profile" />
              ))}
            </div>
          ) : (
            <p className="text-gray-600">No events listed yet.</p>
          )}
        </div>
      )}

      {/* Add Following section */}
      <div className="mt-8">
        <h2 className="text-xl font-bold mb-4">Following</h2>
        {currentUser && <FollowingList userId={currentUser.uid} />}
      </div>
    </div>
  );
};

export default ProfilePage;
